import { CountryCode, getCountryCallingCode } from 'libphonenumber-js'
import { Icon, ISelectProps, Select } from 'native-base'
import { CaretDown } from 'phosphor-react-native'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Platform } from 'react-native'

interface PhoneCountryCodeProps extends ISelectProps {
  countryCodes: CountryCode[]
  selection?: number
  onValueChange?: (value: string) => void
}

export const PhoneCountryCode: React.FC<PhoneCountryCodeProps> = ({ countryCodes = [], onValueChange, ...rest }) => {
  const { t } = useTranslation()
  const width = Platform.OS !== 'web' ? 95 : undefined

  return (
    <Select
      width={width}
      height="48px"
      maxWidth={95} // TODO: get access to underlying native base input to remove margin
      accessibilityLabel={t('inputs.phoneCountryCode.label')}
      onValueChange={onValueChange}
      dropdownIcon={
        <Icon as={<CaretDown color="currentColor" />} accessibilityHidden size="lg" color="gray.600" mr={2} />
      }
      borderWidth={0}
      borderRightWidth={1}
      borderRadius={0}
      borderRightColor="gray.600"
      py={2}
      selection={1} // Focus bug - https://github.com/GeekyAnts/NativeBase/issues/5111
      {...rest}
      // Fix "ERROR VirtualizedLists should never be nested inside plain ScrollViews with the same orientation because
      // it can break windowing and other functionality - use another VirtualizedList-backed container instead."
      // See source code: https://github.com/GeekyAnts/NativeBase/blob/3c130f131a20a371364837b1261fb2131d9a0771/src/components/primitives/Select/Select.tsx#L197-L228
      // Fix from https://github.com/GeekyAnts/NativeBase/issues/5687#issuecomment-1592597437.
      // There are other ways to fix this at https://github.com/GeekyAnts/NativeBase/issues/5717.
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      optimized={false}
    >
      {countryCodes.map(code => {
        const countryPhoneCode = `+${getCountryCallingCode(code)}`
        return <Select.Item label={countryPhoneCode} value={code} key={code} accessibilityLabel={code} />
      })}
    </Select>
  )
}

export default PhoneCountryCode
